export default __webpack_public_path__ + "static/media/ofs_800_reziseal.3a728a71.jpg";